import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctBytes32, FctValue } from '../../../../Fct/generics';
import { secureStorageAddresses } from '../helpers/constants';
export var Read_uint256 = createPlugin({
    protocol: 'SECURE_STORAGE',
    type: 'GETTER',
    method: 'read_uint256',
    supportedContracts: secureStorageAddresses,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({}),
                methodParams: {
                    owner: new FctAddress({}),
                    key: new FctBytes32({ messageType: 'stringOrBytes32' }),
                },
            },
            output: {
                value: new FctValue({}),
            },
        });
    },
});
